"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.FavoriteHomeSVG = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _Icon = require("../Icon");
var _excluded = ["children"];
var FavoriteHomeSVG = function FavoriteHomeSVG(_ref) {
  var children = _ref.children,
    rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/_react.default.createElement("path", {
    stroke: "none",
    d: "M27.29 11.4L17.2 1.9a2 2 0 00-2.4 0L4.71 11.4A2 2 0 004 12.93V28a2 2 0 002 2h20a2 2 0 002-2V12.93a2 2 0 00-.71-1.53zm-7 7.6L16 23.3 11.69 19a2.3 2.3 0 01-.69-1.66 2.33 2.33 0 01.69-1.66 2.38 2.38 0 013.33 0l1 1 1-1a2.37 2.37 0 013.33 0 2.33 2.33 0 01.65 1.66 2.3 2.3 0 01-.69 1.66z"
  }));
};
exports.FavoriteHomeSVG = FavoriteHomeSVG;
FavoriteHomeSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: _propTypes.default.node
} : {};
var _default = (0, _Icon.withIcon)(FavoriteHomeSVG);
exports.default = _default;